import React from 'react';
import classnames from 'classnames';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import AppModal from '@/components/AppModal/AppModal';
import TheButton from '@/components/school-management/TheButton/TheButton';
import classNames from './styles.module.scss';
import { existingUsersInterface } from './ClassModalsManager';

interface ExistingUsersModalProps {
  show: boolean;
  usersData: existingUsersInterface | null;
  onClose: () => void;
  isTeacher?: boolean;
}

const ExistingUsersModal: React.FC<ExistingUsersModalProps> = ({
  show,
  usersData,
  onClose,
  isTeacher,
}) => {
  const { t } = useAdminTranslation();

  if (!show || !usersData) return null;

  const hasValidationErrors = usersData?.existingUsersList?.some(
    user =>
      user.error &&
      !user.error.toLowerCase().includes('already') &&
      !user.error.toLowerCase().includes('User account already exists')
  );

  const getDescriptionMessage = () => {
    if (hasValidationErrors) {
      return isTeacher
        ? t('settings.add_teachers.enrollment_unsuccessful_description_validation')
        : t('settings.add_students.enrollment_unsuccessful_description_validation');
    }
    return isTeacher
      ? t('settings.add_teachers.enrollment_unsuccessful_description')
      : t('settings.add_students.enrollment_unsuccessful_description');
  };

  return (
    <AppModal show={show} type='fade'>
      <div
        className={classnames(
          classNames.modal,
          classNames.existingStudentsModal,
          classNames.fileUploadModal
        )}
      >
        <div className={classNames.existingStudentsModalHeader}>
          <h2>
            {usersData?.addedUsers
              ? isTeacher
                ? t('settings.add_teachers.partial_success')
                : t('settings.add_students.partial_success')
              : isTeacher
                ? t('settings.add_teachers.enrollment_unsuccessful')
                : t('settings.add_students.enrollment_unsuccessful')}
          </h2>
          {!!usersData?.addedUsers && (
            <div
              className={classNames.description}
              dangerouslySetInnerHTML={{
                __html: isTeacher
                  ? t('settings.add_teachers.partial_success_description', {
                      addedTeachers: usersData?.addedUsers,
                      totalTeachers: usersData?.totalUsers,
                    }).toString()
                  : t('settings.add_students.partial_success_description', {
                      addedStudents: usersData?.addedUsers,
                      totalStudents: usersData?.totalUsers,
                    }).toString(),
              }}
            />
          )}
          <div className={classNames.description}>{getDescriptionMessage()}</div>
        </div>

        <div className={classNames.existingStudentsList}>
          <div className={classNames.existingStudentsHead}>
            <div>{t('form.firstName')}</div>
            <div>{t('form.lastName')}</div>
            <div>{t('form.email')}</div>
          </div>
          <div className={classNames.existingStudentsBody}>
            {usersData?.existingUsersList?.map((user, index) => (
              <div
                key={`existingStudentsListItem--${index}`}
                className={classNames.existingStudentsListItem}
              >
                <div>{user.firstName}</div>
                <div>{user.lastName}</div>
                <div>{user.email}</div>
              </div>
            ))}
          </div>
        </div>

        <div className={classNames.buttons}>
          <TheButton
            className={classNames.btn}
            text={t('ok')}
            shouldRecolor={false}
            emitOnClick={onClose}
          />
        </div>
      </div>
    </AppModal>
  );
};

export default ExistingUsersModal;
